/** Nav/settings gates for seller shared-access delegates. No nav imports. */

const SHARED_ACCESS_ALWAYS = new Set(["profile", "settings", "help"]);

// INV.5 renamed the seller Inventory pages; saved grants keep the old ids.
const LEGACY_IDS = {
  "inventory-seller/my-stock": ["inventory-seller/my-inventory"],
  "inventory-seller/send": [
    "inventory-seller/send-stock",
    "inventory-seller/add-product",
    "inventory-seller/enroll",
  ],
  "inventory-seller/shipments": [
    "inventory-seller/variances",
    "inventory-seller/send-stock",
  ],
};

export function isSharedAccessDelegate(user) {
  return !!(user?.invitedSharedAccess && !user?.sharedAccessRevoked);
}

export function isSharedAccessRestricted(user) {
  return (
    isSharedAccessDelegate(user) && user?.sharedAccess?.mode === "custom"
  );
}

export function hasSharedAccessPermission(user, permissionId) {
  if (!user) return false;
  if (!isSharedAccessDelegate(user)) return true;
  const access = user.sharedAccess || {};
  if (access.mode !== "custom") return true;
  const perms = Array.isArray(access.permissions) ? access.permissions : [];
  if (!permissionId) return false;
  if (perms.includes(permissionId)) return true;
  if ((LEGACY_IDS[permissionId] || []).some((id) => perms.includes(id))) return true;
  const prefix = `${permissionId}/`;
  return perms.some((p) => typeof p === "string" && p.startsWith(prefix));
}

export function applySharedAccessVisibility(user, visibility) {
  if (!visibility) return visibility;
  const next = { ...visibility };
  if (isSharedAccessDelegate(user)) {
    next["team-access/share-access"] = false;
  }
  if (!isSharedAccessRestricted(user)) return next;
  Object.keys(next).forEach((id) => {
    if (next[id] === false) return;
    if (SHARED_ACCESS_ALWAYS.has(id)) return;
    if (!hasSharedAccessPermission(user, id)) next[id] = false;
  });
  return next;
}
